// import twoFingerMapboxPan from "./mapbox-two-finger-pan";
import MultiTouch from "mapbox-gl-multitouch";

// mapboxgl.accessToken =
//   "pk.eyJ1IjoiZnVsbHlzdHVkaW9zIiwiYSI6ImNrM2FsdmhmZjBjenAzZWt3am5qYzRpM3UifQ.4GN9153j_a9pIDCQg44gEQ";

// export var map = new mapboxgl.Map({
//   container: "map", // HTML container id
//   style: "mapbox://styles/fullystudios/ck3ga5m2s0a7a1cpfiy4bub4x",
//   center: [11.950711, 57.699588], // starting position
//   zoom: 11 // starting zoom
// });

document.addEventListener("DOMContentLoaded", function(event) {
  // Mapbox
  mapboxgl.accessToken =
    "pk.eyJ1IjoiZnVsbHlzdHVkaW9zIiwiYSI6ImNrM2FsdmhmZjBjenAzZWt3am5qYzRpM3UifQ.4GN9153j_a9pIDCQg44gEQ";

  var map = new mapboxgl.Map({
    container: "map", // HTML container id
    style: "mapbox://styles/fullystudios/ck3ga5m2s0a7a1cpfiy4bub4x",
    center: [11.950711, 57.699588], // starting position
    zoom: 11 // starting zoom
  });
  //Two finger panning on touchscreens
  map.addControl(new MultiTouch());

  // document.addEventListener(
  //   "touchstart",
  //   function() {
  //     twoFingerMapboxPan(map);
  //   },
  //   false
  // );

  // This works on mobile but not desktop
  //   twoFingerMapboxPan(map);

  // Add zoom and rotation controls to the map.
  map.addControl(new mapboxgl.NavigationControl());
  // Disable scroll zoom
  map.scrollZoom.disable();
});
